import { render, staticRenderFns } from "./InfoCallout.vue?vue&type=template&id=2c791ed6&scoped=true&"
import script from "./InfoCallout.vue?vue&type=script&lang=js&"
export * from "./InfoCallout.vue?vue&type=script&lang=js&"
import style0 from "./InfoCallout.vue?vue&type=style&index=0&id=2c791ed6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c791ed6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2c791ed6', component.options)
    } else {
      api.reload('2c791ed6', component.options)
    }
    module.hot.accept("./InfoCallout.vue?vue&type=template&id=2c791ed6&scoped=true&", function () {
      api.rerender('2c791ed6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/containers/InfoCallout.vue"
export default component.exports